/* DeviceGridViewComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./DeviceGridViewRenderer");
const Registrations = require("../../../../../RegistrationNamespaces");
const PlatformSdk = require("@gluenetworks/platform-sdk-remote");
const OsUpgradePlanEntity = PlatformSdk.entities.ws.OsUpgradePlan;

const DeviceTypeColumn = require("./column_renderers/device_type/DeviceTypeComponent");
const DeviceDiscoveryStatusColumn = require("./column_renderers/discovery_status/DeviceDiscoveryStatusComponent");
const DeviceCaptureStatusColumn = require("./column_renderers/capture_status/DeviceCaptureStatusComponent");
const ManagementStateColumn = require("./column_renderers/management_state/ManagementStateComponent");
const DiscoveryLevelColumn = require("./column_renderers/discovery_level/DiscoveryLevelComponent");
const EnvironmentColumn = require("./column_renderers/environment/EnvironmentComponent");
const DateColumn = require("./column_renderers/date/DateComponent");
const UptimeColumn = require("./column_renderers/uptime/UptimeComponent");
const LicenseColumn = require("./column_renderers/licence_status/DeviceLicenseStatusComponent");
const CustomFieldsColumn = require("./column_renderers/custom_fields/CustomFieldsComponent");
const SitePathColumn = require("./column_renderers/site_path/SitePathComponent");
// const DefaultFileServerColumn = require("./column_renderers/default_file_server/DefaultFileServerComponent");
const HaGroupColumn = require("./column_renderers/ha_pair/HaPairComponent");
const AccessStatusColumn = require("./column_renderers/access_status/AccessStatusComponent");
const DeviceAuditStatusColumn = require("./column_renderers/audit_status/AuditStatusComponent");
const PlanStatusColumn = require("./column_renderers/plan_status/PlanStatusComponent");
const SiteTypeColumn = require("./column_renderers/site_type/SiteTypeComponent");
const SiteCodeColumn = require("./column_renderers/site_code/SiteCodeComponent");
const ControlTypeColumn = require("./column_renderers/control_type/ControlTypeComponent");
const CmdbSyncStatusColumn = require("./column_renderers/cmdb_sync_status/CmdbSyncStatusComponent.js");
const ExposureDisplayStatusColumn = require("./column_renderers/exposure_status/ExposureDisplayStatusComponent");
const TagsColumn = require("../../../../column_renderers/tags/TagsComponent");
// const DefaultNumericColumn = require("./column_renderers/default_numeric/DefaultNumericComponent");
const PagingDeviceFeed = require("./PagingDeviceFeed");
const TreeUtils = require("../../../siteexplorer/treeUtilities.js");
const {applyExposureLicenseGate} = require("../../../../lib/exposureLicenseGate");

const _ = require("lodash");

const {
    DEVICE_CAPTURE_STATUSES,
    DEVICE_DISCOVERY_STATUSES,
    AUDIT_STATUSES,
    DEVICE_CUSTOM_FIELDS,
    DEVICE_MANAGEMENT_STATES,
    DEVICE_ENVIRONMENTS,
    LICENSE_STATUS,
    SOLUTION_DEFAULT_SHOWN_COLUMNS,
    LICENSE_RESTRICTED_COLUMNS,
    EXPOSURE_DISPLAY_STATUSES,
} = require("./deviceConstants");
class DeviceGridViewComponent extends EventEmitter {
    constructor(
        logger,
        gameEditor,
        steveUtils,
        DeviceEntity,
        VendorApiConfigEntity,
        CustomFieldsEntity,
        userSession,
        storageFactory,
        solutionsManager,
        modalUserFeedback,
        licenseRestriction,
        OsImageServerEntity,
        di,
        SiteEntity,
        CredentialsEntity,
        ConstructType,
        ExtendedPropType,
        Tags
    ) {
        super(di);
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._steveUtils = steveUtils;
        this._DeviceEntityDef = DeviceEntity;
        this._VendorApiConfigEntityDef = VendorApiConfigEntity;
        this._CustomFieldsEntityDef = CustomFieldsEntity;
        this._userSession = userSession;
        this._constructTypeEntityDef = ConstructType;
        this._extendedPropTypeEntityDef = ExtendedPropType;
        this._TagsEntity = Tags;
        this._modalUserFeedback = modalUserFeedback;
        this._solutionsManager = solutionsManager;
        this._solutionName =
            (solutionsManager.activeSolution && solutionsManager.activeSolution.name) || "";
        this._gridKey = _.camelCase(this._solutionName) + "_" + "deviceExplorer";
        this._storageFactory = storageFactory;
        this._userGridData = undefined; //new UserGridData(this._gridKey);
        this._pagingDeviceFeed = undefined;
        this._controlledDeviceNames = [];
        this._controlledDeviceIDs = [];
        this._nodeProps = {};
        this._isCiscoSupportEnabled = undefined;
        this._siteEntityDef = SiteEntity;
        this._osImageServerEntity = OsImageServerEntity;
        this._isNistSupportEnabled = undefined;
        this._hasTopologyLicense = false;
        this._hasTopologyAccess = false;
        this._renderer = new Renderer(this);
        this._explorerState = {
            selectedIds: [],
            //openedEditor: undefined,
            openedTabs: {},
            activeTab: undefined,
        };

        this._optionMapSitePaths = [];

        this.columns = undefined;
        this._customFieldColumnsEntity = undefined;
        this._vendorApiConfigEntity = undefined;
        this._isEmitCustomFieldEvent = undefined;
        this._sessionStorage = undefined; //new UserGridData(`${this._gridKey}_explorerState`, null, { storageKey: 'deviceExplorer_explorerState', storageType: 'session' });
        this._osMap = undefined;
        this._licenseRestriction = licenseRestriction;
        this._CDALicenseEnabled = false;
        this._TAILicenseEnabled = false;
        this._di = di;
        this._credentialsEntityDef = CredentialsEntity;
        this._credentialNameOptions = {};
    }

    get columnConfig() {
        if (this.columns) {
            return this.columns;
        }

        const vendorsMap = this._gameEditor._vendorMap,
            accessStatusLabels = this._DeviceEntityDef.getAccessStatusLabels();

        //creating a new static DEVICE_TYPES list to pass to filter dropdown for types (via options)
        //TODO: create a non-redundant list directly in the filter
        const typeBaseMap = this._gameEditor._typeBaseMap;
        const optionMapDeviceTypes = {};
        _.sortBy(Object.keys(typeBaseMap)).map(function (key) {
            optionMapDeviceTypes[key] = {
                name: typeBaseMap[key],
                title: typeBaseMap[key],
            };
        });

        const optionMapAccessStatus = {};
        Object.keys(accessStatusLabels).forEach(
            (accessLabel) =>
                (optionMapAccessStatus[accessLabel] = {
                    name: accessLabel,
                    title: accessStatusLabels[accessLabel],
                })
        );

        const optionControlType = {};
        Object.keys(this._DeviceEntityDef.getControlTypeLabels()).forEach(
            (controlType) =>
                (optionControlType[controlType] = {
                    name: controlType,
                    title: this._DeviceEntityDef.getControlTypeLabels()[controlType],
                })
        );

        const optionRestoreStatus = {};
        Object.keys(this._DeviceEntityDef.getLastRestoredStatusLabels()).forEach(
            (status) =>
                (optionRestoreStatus[status] = {
                    name: status,
                    title: this._DeviceEntityDef.getLastRestoredStatusLabels()[status],
                })
        );

        const optionBackupStatus = {};
        Object.keys(this._DeviceEntityDef.getLastBackupStatusLabels()).forEach(
            (status) =>
                (optionBackupStatus[status] = {
                    name: status,
                    title: this._DeviceEntityDef.getLastBackupStatusLabels()[status],
                })
        );

        const optionsSyncStatus = {};
        const optionsSyncStatusLabels = this._DeviceEntityDef.getCmdbSyncStatusLabels();
        Object.keys(optionsSyncStatusLabels).forEach((cmdbSyncStatus) => {
            optionsSyncStatus[cmdbSyncStatus] = {
                name: cmdbSyncStatus,
                title: optionsSyncStatusLabels[cmdbSyncStatus],
            };
        });

        const serversMap = this.gameEditor.osImageServers.map(({name}) => ({
            title: name,
            name,
        }));

        this.columns = {
            grouping: {
                priority: 0,
                label: "Group",
                width: 220,
                entityColumn: true,
                isGroupingColumn: true,
            },
            detectedTypeBase: {
                label: "Type",
                columnRendererComponent: DeviceTypeColumn,
                entityColumn: true,
                width: 45,
                resizable: false,
                options: optionMapDeviceTypes,
                groupable: true,
            },
            name: {
                label: "Name",
                groupable: false,
                width: 220,
            },
            description: {
                label: "Description",
                width: 300,
                groupable: false,
            },
            managementState: {
                label: "Management State",
                columnRendererComponent: ManagementStateColumn,
                groupable: true,
                options: DEVICE_MANAGEMENT_STATES,
                width: 140,
            },
            discoveryLevel: {
                label: "Discovery Level",
                columnRendererComponent: DiscoveryLevelColumn,
                options: Object.entries(this._DeviceEntityDef.getDiscoveryLevelLabels()).reduce(
                    (acc, [val, title]) => {
                        acc[val] = {name: val, title};
                        return acc;
                    },
                    {}
                ),
                groupable: true,
                width: 140,
            },
            environment: {
                label: "Environment",
                columnRendererComponent: EnvironmentColumn,
                groupable: true,
                options: DEVICE_ENVIRONMENTS,
                width: 140,
            },
            controlType: {
                label: "Controller Type",
                columnRendererComponent: ControlTypeColumn,
                groupable: true,
                width: 140,
                context: {
                    controlTypes: this._DeviceEntityDef.getControlTypeLabels(),
                },
                options: optionControlType,
            },
            controllerName: {
                label: "Controller Name",
                groupable: true,
                width: 140,
            },
            connectionMethodDisplayName: {
                label: "Connection Method",
                groupable: true,
                width: 140,
            },
            sitePath: {
                label: "Site Path",
                groupable: true,
                width: 160,
                columnRendererComponent: SitePathColumn,
                context: {
                    orgName: this._userSession.activeOrganization.name,
                },
            },
            siteName: {
                label: "Site Name",
                groupable: false,
                width: 160,
            },
            siteCodeName: {
                label: "Site Code Name",
                columnRendererComponent: SiteCodeColumn,
                entityColumn: true,
                groupable: true,
                width: 160,
                context: {
                    hasTopologyLicense: this._hasTopologyLicense,
                    hasTopologyAccess: this._hasTopologyAccess,
                },
            },
            siteLocationType: {
                label: "Site Type",
                groupable: true,
                width: 160,
                options: Object.entries(this._siteEntityDef.getLocationTypeLabels()).map(
                    ([value, title]) => ({name: value, title})
                ),
                columnRendererComponent: SiteTypeColumn,
                context: {
                    _labels: this._siteEntityDef.getLocationTypeLabels(),
                },
            },
            allowSiteAutoAssignment: {
                label: "Allow site auto-assignment",
                groupable: true,
                width: 220,
                columnRendererComponent: CustomFieldsColumn,
            },
            licensed: {
                label: "Licensed",
                groupable: true,
                columnRendererComponent: LicenseColumn,
                options: LICENSE_STATUS,
                width: 140,
            },
            ip: {
                label: "IP Address",
                path: "connectionInformation.ip",
                width: 140,
                groupable: false,
            },
            credsName: {
                label: "Credential",
                groupable: true,
                options: this._credentialNameOptions,
                width: 150,
            },
            detectedVendor: {
                label: "Vendor",
                groupable: true,
                width: 140,
                options: Object.entries(vendorsMap).map(([, title]) => ({name: title, title})),
            },
            detectedHostName: {
                label: "Hostname",
                width: 140,
                groupable: false,
            },
            detectedOs: {
                label: "OS",
                width: 140,
                groupable: true,
                options: Object.entries(this._osMap).map(([, title]) => ({name: title, title})),
            },
            detectedSoftwareVersion: {
                label: "OS Version",
                width: 140,
                groupable: true,
            },
            detectedPlatform: {
                label: "OS Platform",
                width: 200,
                groupable: true,
            },
            detectedSerialNumber: {
                label: "Serial",
                groupable: false,
                width: 140,
            },
            detectedSku: {
                label: "SKUs",
                groupable: true,
                width: 140,
            },
            detectedUptime: {
                label: "Up Time",
                columnRendererComponent: UptimeColumn,
                width: 120,
                dataType: "duration",
                filterLabel: "Up Time (Days)",
                groupable: false,
            },
            elementCount: {
                label: "Elements",
                width: 110,
                dataType: "number",
                groupable: false,
            },
            totalCount: {
                label: "Switchports Total",
                width: 110,
                dataType: "number",
                path: "portSummary.totalCount",
                groupable: false,
            },
            useCount: {
                label: "Switchports Used",
                width: 110,
                dataType: "number",
                path: "portSummary.useCount",
                groupable: false,
            },
            freeCount: {
                label: "Switchports Free",
                width: 110,
                dataType: "number",
                path: "portSummary.freeCount",
                groupable: false,
            },
            usePercent: {
                label: "Switchports Used %",
                width: 110,
                dataType: "number",
                path: "portSummary.usePercent",
                groupable: false,
            },
            freePercent: {
                label: "Switchports Free %",
                width: 110,
                dataType: "number",
                path: "portSummary.freePercent",
                groupable: false,
            },
            zoneName: {
                label: "Zone",
                groupable: true,
                width: 160,
            },
            licenseCount: {
                label: "License Count",
                groupable: false,
                width: 110,
            },
            configuredInfo: {
                label: "Configured Info",
                width: 160,
                groupable: true,
            },
            configuredType: {
                label: "Configured Type",
                width: 120,
                groupable: true,
            },
            configuredBy: {
                label: "Configured By",
                width: 120,
                groupable: true,
            },
            rebootedBy: {
                label: "Rebooted By",
                width: 120,
                groupable: true,
            },
            configuredOn: {
                label: "Configured On",
                width: 160,
                columnRendererComponent: DateColumn,
                groupable: false,
            },
            rebootedOn: {
                label: "Rebooted On",
                width: 120,
                columnRendererComponent: DateColumn,
                groupable: false,
            },
            updatedOn: {
                label: "Updated On",
                columnRendererComponent: DateColumn,
                width: 160,
                groupable: false,
            },
            updatedBy: {
                label: "Updated By",
                width: 120,
                groupable: true,
            },
            lastBackupStatus: {
                label: "Backup Status",
                width: 120,
                groupable: true,
                options: optionBackupStatus,
            },
            lastBackupOn: {
                label: "Backup On",
                columnRendererComponent: DateColumn,
                width: 120,
                groupable: false,
            },
            lastBackedUpBy: {
                label: "Backup By",
                width: 120,
                groupable: true,
            },
            lastSuccessfulBackupName: {
                label: "Last Successful Backup Name",
                width: 120,
                groupable: true,
            },
            lastSuccessfulBackupOn: {
                label: "Last Successful Backup On",
                columnRendererComponent: DateColumn,
                groupable: false,
            },
            lastRestoredStatus: {
                label: "Restore Status",
                width: 120,
                groupable: true,
                options: optionRestoreStatus,
            },
            lastRestoredProgress: {
                label: "Restore Progress",
                width: 120,
                groupable: true,
            },
            lastRestoredOn: {
                label: "Restored On",
                columnRendererComponent: DateColumn,
                width: 120,
                groupable: false,
            },
            lastRestoredBy: {
                label: "Restored By",
                width: 120,
                groupable: true,
            },
            lastRestoredBackupName: {
                label: "Restored Backup Name",
                width: 120,
                groupable: true,
            },
            lastRestoredBackupFrom: {
                label: "Restored Backup From",
                columnRendererComponent: DateColumn,
                width: 120,
                groupable: false,
            },
            lastActivityType: {
                label: "Last Activity Type",
                groupable: true,
            },
            lastActivityOn: {
                label: "Last Activity On",
                columnRendererComponent: DateColumn,
                width: 160,
                groupable: false,
            },
            lastActivityBy: {
                label: "Last Activity By",
                width: 120,
                groupable: true,
            },
            lastActivityError: {
                label: "Last Activity Error",
                groupable: true,
            },
            accessStatus: {
                label: "Access Status",
                groupable: true,
                columnRendererComponent: AccessStatusColumn,
                options: optionMapAccessStatus,
            },
            cmdbCiId: {
                label: "CMDB CI ID",
                groupable: false,
            },
            cmdbCiName: {
                label: "CMDB CI Name",
                groupable: false,
            },
            cmdbClassName: {
                label: "CMDB Class Name",
                groupable: true,
            },
            cmdbSyncStatus: {
                label: "CMDB Sync Status",
                groupable: true,
                options: optionsSyncStatus,
                columnRendererComponent: CmdbSyncStatusColumn,
                context: {
                    cmdbSyncStatusOptions: this._DeviceEntityDef.getCmdbSyncStatusLabels(),
                },
            },
            lastCmdbSyncBy: {
                label: "Last CMDB Sync By",
                groupable: false,
            },
            lastCmdbSyncError: {
                label: "Last CMDB Sync Error",
                groupable: true,
            },
            lastCmdbSyncOn: {
                label: "Last CMDB Sync On",
                groupable: false,
                columnRendererComponent: DateColumn,
            },
            latestHaveIChangedLastChecked: {
                label: "Captured On",
                columnRendererComponent: DateColumn,
                groupable: false,
            },
            latestHaveIChanged: {
                label: "Captured Status",
                columnRendererComponent: DeviceCaptureStatusColumn,
                width: 140,
                options: DEVICE_CAPTURE_STATUSES,
                groupable: true,
            },
            capturedBy: {
                label: "Captured By",
                width: 120,
                groupable: true,
            },
            auditCriticalViolationCount: {
                label: "Critical Violations",
                width: 130,
                groupable: false,
            },
            auditMajorViolationCount: {
                label: "Major Violations",
                width: 120,
                groupable: false,
            },
            auditMinorViolationCount: {
                label: "Minor Violations",
                width: 120,
                groupable: false,
            },
            auditInfoViolationCount: {
                label: "Informational Violations",
                width: 175,
                groupable: false,
            },
            auditViolationCount: {
                label: "Total Violations",
                width: 120,
                groupable: false,
            },
            auditedOn: {
                label: "Audited On",
                columnRendererComponent: DateColumn,
                width: 160,
                groupable: false,
            },
            auditedBy: {
                label: "Audited By",
                width: 120,
                groupable: true,
            },
            auditStatus: {
                label: "Audit Status",
                columnRendererComponent: DeviceAuditStatusColumn,
                options: AUDIT_STATUSES,
                groupable: true,
                width: 140,
            },
            lastAuditPolicy: {
                label: "Audit Policy",
                groupable: true,
            },
            fileServerName: {
                label: "File Server",
                shown: this.gameEditor.isOSMSolutionAvailable,
                options: serversMap,
                groupable: true,
            },
            vrf: {
                label: "VRF",
                groupable: true,
            },
            haPairName: {
                label: "HA Group",
                entityColumn: true,
                columnRendererComponent: HaGroupColumn,
                context: {
                    gameEditor: this._gameEditor,
                },
                groupable: true,
            },
            useIssu: {
                label: "Non-disruptive",
                width: 80,
                description: "Require non-disruptive upgrade",
                columnRendererComponent: CustomFieldsColumn,
                groupable: true,
            },
            discoveredOn: {
                label: "Discovered On",
                columnRendererComponent: DateColumn,
                width: 160,
                groupable: false,
            },
            discoveryStatus: {
                label: "Discovered Status",
                columnRendererComponent: DeviceDiscoveryStatusColumn,
                width: 160,
                options: DEVICE_DISCOVERY_STATUSES,
                groupable: true,
            },
            exposureDisplayStatus: {
                label: "Exposure Status",
                width: 140,
                dataType: "enum",
                options: EXPOSURE_DISPLAY_STATUSES,
                columnRendererComponent: ExposureDisplayStatusColumn,
                entityColumn: true,
                context: {
                    statusLabels: _.mapValues(EXPOSURE_DISPLAY_STATUSES, "title"),
                },
                groupable: true,
                shown: false,
            },
            exposureEvaluatedOn: {
                label: "Exposure Evaluated On",
                width: 160,
                dataType: "date",
                columnRendererComponent: DateColumn,
                groupable: false,
                shown: false,
            },
            exposureExposedCount: {
                label: "Exposure Affected CVE Count",
                width: 130,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposureExposedCriticalCount: {
                label: "Exposure Affected Critical",
                width: 120,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposureExposedHighCount: {
                label: "Exposure Affected High",
                width: 110,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposureExposedMediumCount: {
                label: "Exposure Affected Medium",
                width: 120,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposureExposedLowCount: {
                label: "Exposure Affected Low",
                width: 110,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposureExposedInformationalCount: {
                label: "Exposure Affected Info",
                width: 120,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposureExposedUnratedCount: {
                label: "Exposure Affected Unrated",
                width: 120,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposurePotentialCount: {
                label: "Exposure Potential Count",
                width: 140,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposurePotentialCriticalCount: {
                label: "Exposure Potential Critical",
                width: 140,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposurePotentialHighCount: {
                label: "Exposure Potential High",
                width: 140,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposurePotentialMediumCount: {
                label: "Exposure Potential Medium",
                width: 140,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposurePotentialLowCount: {
                label: "Exposure Potential Low",
                width: 140,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposurePotentialInformationalCount: {
                label: "Exposure Potential Info",
                width: 140,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposurePotentialUnratedCount: {
                label: "Exposure Potential Unrated",
                width: 140,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposureInconclusiveCount: {
                label: "Exposure Inconclusive Count",
                width: 140,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposureInconclusiveCriticalCount: {
                label: "Exposure Inconclusive Critical",
                width: 140,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposureInconclusiveHighCount: {
                label: "Exposure Inconclusive High",
                width: 140,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposureInconclusiveMediumCount: {
                label: "Exposure Inconclusive Medium",
                width: 140,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposureInconclusiveLowCount: {
                label: "Exposure Inconclusive Low",
                width: 140,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposureInconclusiveInformationalCount: {
                label: "Exposure Inconclusive Info",
                width: 140,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposureInconclusiveUnratedCount: {
                label: "Exposure Inconclusive Unrated",
                width: 140,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            exposureNotAffectedCount: {
                label: "Exposure Not Affected Count",
                width: 140,
                dataType: "number",
                groupable: false,
                shown: false,
            },
            discoveredBy: {
                label: "Discovered By",
                width: 120,
                groupable: true,
            },
            osUpgradeStatus: {
                label: "OSM Action Status",
                groupable: true,
                columnRendererComponent: PlanStatusColumn,
                options: this._getOsPlanDataForAdvancedFilter(
                    this._DeviceEntityDef.getOsUpgradeStatusValues()
                ),
                context: {
                    _planStatusList: this._DeviceEntityDef.getOsUpgradeStatusValues(),
                },
            },
            osUpgradedBy: {
                label: "OSM Action By",
                groupable: true,
            },
            osUpgradedOn: {
                label: "OSM Action On",
                groupable: false,
                columnRendererComponent: DateColumn,
            },
            osUpgradeError: {
                label: "OSM Action Error",
                groupable: true,
            },
            osUpgradePlanId: {
                label: "OS Plan ID ",
                groupable: false,
            },
            osUpgradePlanName: {
                label: "OS Plan Name",
                groupable: true,
            },
            osUpgradePlanAction: {
                label: "OS Plan Action",
                groupable: true,
            },
            tagNames: {
                label: "Tags",
                filterLabel: "Tag Name",
                columnRendererComponent: TagsColumn,
                width: 160,
                dataType: "array",
                groupable: false,
                shown: false,
            },
        };

        // Get current solution name and determine which columns should be shown
        const currentSolutionName = this.gameEditor.currentSolutionName || "device_manager";
        const defaultShownColumns =
            SOLUTION_DEFAULT_SHOWN_COLUMNS[currentSolutionName] ||
            SOLUTION_DEFAULT_SHOWN_COLUMNS["device_manager"];

        Object.keys(this.columns).forEach((columnKey) => {
            // Set 'shown' property to true for each column based on SOLUTION_DEFAULT_SHOWN_COLUMNS
            // and assign a priority to each column
            if (defaultShownColumns.includes(columnKey)) {
                this.columns[columnKey].shown = true;
                this.columns[columnKey].priority = defaultShownColumns.indexOf(columnKey) + 1;
            } else {
                this.columns[columnKey].shown = false;
            }
        });

        // Filter out license-restricted columns if user doesn't have the required license
        const hasCDALicense = this._licenseRestriction?.checkLicense("CDA");
        const hasOSMLicense = this._licenseRestriction?.checkLicense("OSM");

        if (!hasCDALicense && LICENSE_RESTRICTED_COLUMNS.CDA) {
            LICENSE_RESTRICTED_COLUMNS.CDA.forEach((columnKey) => {
                delete this.columns[columnKey];
            });
        }

        if (!hasOSMLicense && LICENSE_RESTRICTED_COLUMNS.OSM) {
            LICENSE_RESTRICTED_COLUMNS.OSM.forEach((columnKey) => {
                delete this.columns[columnKey];
            });
        }

        if (!this._TAILicenseEnabled && LICENSE_RESTRICTED_COLUMNS.TAI) {
            LICENSE_RESTRICTED_COLUMNS.TAI.forEach((columnKey) => {
                delete this.columns[columnKey];
            });
        }

        Object.values(this.columns).forEach((col) => {
            if (col.options !== undefined && col.dataType === undefined) {
                col.dataType = "enum";
            }
        });

        return this.columns;
    }

    get pagingFeed() {
        return this._pagingDeviceFeed;
    }

    get selectedRows() {
        return this._renderer.selectedRows;
    }

    get activeOrgId() {
        return this._userSession.activeOrganization.id;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        // this._solutionsManager.on("activeSolutionChanged", (this._onSolutionChanged = this._onSolutionChanged.bind(this)));
        this._storageFactory.on(
            "storageReady",
            (this._onStorageReady = this._onStorageReady.bind(this))
        );
        this._gameEditor.on(
            "EditorLaunched",
            (this._onEditorLaunched = this._onEditorLaunched.bind(this))
        );
        this._gameEditor.on(
            "EditorClosed",
            (this._onEditorClosed = this._onEditorClosed.bind(this))
        );
        this._gameEditor.on("ActiveTabChanged", this._onActiveTabChanged.bind(this));
    }

    _unregisterListeners() {
        // this._solutionsManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
        if (this._storageFactory) {
            this._storageFactory.removeListener("storageReady", this._onStorageReady);
        }
        if (this._gameEditor) {
            // this._gameEditor.removeListener("EditorLaunched", this._onEditorLaunched);
            // this._gameEditor.removeListener("EditorClosed", this._onEditorClosed);
            // this._gameEditor.removeListener("ActiveTabChanged", this._onActiveTabChanged);
            this._gameEditor.removeAllListeners();
        }
    }

    _patchSorting(sorting) {
        // add second sorting order by name
        if (sorting && !sorting.name && this.columnConfig.name) {
            sorting.name = 1;
        }
    }

    _registerFeedListeners() {}

    _unregisterFeedListeners() {}

    _registerUpdatedColumnListeners() {
        this._customFieldColumnsEntity.on(
            "PropertiesUpdated",
            (this._onPropertiesUpdated = this._onPropertiesUpdated.bind(this))
        );
    }

    _unregisterUpdatedColumnListeners() {
        if (this._customFieldColumnsEntity) {
            this._customFieldColumnsEntity.removeListener(
                "PropertiesUpdated",
                this._onPropertiesUpdated
            );
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    whenModelIsReady(selectedSite) {
        return this.gameEditor
            .whenInitialized()
            .then(() => this._resolveLicenseFlags())
            .then(() => this._getNodeProps())
            .then(() => {
                return this._DeviceEntityDef
                    .loadAndMergeOsMap(this._gameEditor._activeOrgId)
                    .then((val) => {
                        this._osMap = val;
                        return Promise.resolve();
                    });
            })
            .then(() => {
                this._userGridData = this._storageFactory.getRemoteStorageInstanceForEntityGrid(
                    "entity_grid_gl",
                    this._gridKey
                );
                this._sessionStorage = this._storageFactory.getSessionStorageInstance(
                    "entity_grid_gl",
                    `${this._gridKey}_explorerState`
                );
                this._explorerState = Object.assign(
                    {},
                    this._explorerState,
                    this._sessionStorage.getData()
                );
            })
            .then(() => this._getExtendedPropTypes())
            .then(() => this._getAllTags())
            .then((tagOptions) => {
                this._tagOptions = tagOptions;
                return Promise.all([
                    this._VendorApiConfigEntityDef.loadVendorApiConfig(this.activeOrgId, {
                        vendors: true,
                    }),
                    this._CustomFieldsEntityDef.loadColumnDefinitions(this.activeOrgId),
                    this._CustomFieldsEntityDef.retrieveCustomFields(this.activeOrgId),
                ]);
            })
            .then(async (response) => {
                const vendorApiConfig = response[0],
                    customFieldColumns = response[1],
                    customColumnsEntity = response[2];
                this.treeData = TreeUtils.generateTreeNodesFromRaw(
                    this.gameEditor.sitePaths,
                    "path",
                    selectedSite
                ).items;

                if (
                    vendorApiConfig &&
                    vendorApiConfig.properties.vendors &&
                    vendorApiConfig.properties.vendors.cisco &&
                    typeof vendorApiConfig.properties.vendors.cisco.enabled !== "undefined"
                ) {
                    this._isCiscoSupportEnabled = vendorApiConfig.properties.vendors.cisco.enabled;
                } else {
                    this._isCiscoSupportEnabled = false;
                }
                if (
                    vendorApiConfig &&
                    vendorApiConfig.properties.vendors &&
                    vendorApiConfig.properties.vendors.nist &&
                    typeof vendorApiConfig.properties.vendors.nist.enabled !== "undefined"
                ) {
                    this._isNistSupportEnabled = vendorApiConfig.properties.vendors.nist.enabled;
                } else {
                    this._isNistSupportEnabled = false;
                }
                // return this._CustomFieldsEntityDef.loadColumnDefinitions(this.activeOrgId);
                // })
                // .then((customFieldColumns) => {
                this._hasTopologyLicense = this._licenseRestriction.checkLicense("TOP");
                this._hasTopologyAccess =
                    _.get(this._userSession, "_userEntity.authorizedActions", []).indexOf(
                        "topologyAccess"
                    ) >= 0;
                let additionalDataFields = [
                    "exposureActivity",
                    "exposureStatus",
                    "connectionMethod",
                    "connectionInformation",
                    "customFieldValues",
                    "detectedRawTypeBase",
                    "engineZoneId",
                    "cves",
                    "siteId",
                    "lockEngine",
                    "nodeProps",
                    "discoveryLevelFrom",
                    "customFieldSources",
                    "baseControlType",
                    "edpValues",
                ];

                // Get existing labels from columnConfig to avoid duplicates with nodeProps
                const existingLabels = new Set(
                    Object.values(this.columnConfig).map((prop) => prop.label)
                );

                // Add nodeProps to columnConfig
                Object.entries(this._nodeProps).forEach(([rawId, props]) => {
                    const label = rawId.replace(/[\t\n\r ]+/g, " ");
                    const technicalId = label.replace(/ /g, "");

                    // Skip if already in columnConfig
                    if (existingLabels.has(label)) {
                        return;
                    }

                    // Add nodeProp to columnConfig
                    this.columnConfig[technicalId] = {
                        ...props,
                        id: technicalId,
                        label,
                        path: `nodeProps["${rawId}"]`,
                        dataType: props.type,
                        shown: false,
                    };

                    // Add options for enum types
                    let options = undefined;
                    if (props.type === "enum") {
                        if (props.options && Object.keys(props.options).length > 0) {
                            // Shallow clone to avoid mutating source
                            this.columnConfig[technicalId].options = {...props.options};
                        } else if (Array.isArray(props.values)) {
                            // Convert array of values to object map
                            this.columnConfig[technicalId].options = props.values.reduce(
                                (acc, val) => {
                                    acc[val] = {name: val, title: val};
                                    return acc;
                                },
                                {}
                            );
                        } else {
                            this.columnConfig[technicalId].options = {};
                        }
                    }
                });

                let customFieldOrder = _.map(DEVICE_CUSTOM_FIELDS, "id");

                let enabledCustomColumns = Object.entries(customFieldColumns)
                    .filter(
                        ([id, customField]) =>
                            customField.enabled === true &&
                            (customField.systemOwned !== true ||
                                _.get(
                                    customColumnsEntity,
                                    `_pristineProperties.fields.${id}.source`,
                                    ""
                                ) === "ControllerDiscoveryConfig" ||
                                this._isCiscoSupportEnabled ||
                                this._isNistSupportEnabled ||
                                this._gameEditor._xDomeEnabled)
                    )
                    .map(([key, customField]) => {
                        // Update order value for pre-ordered custom fields
                        customField = customFieldOrder.includes(key)
                            ? _.set(customField, "order", customFieldOrder.indexOf(key))
                            : customField;
                        return [key, customField];
                    })
                    .sort(([, /*aKey*/ aCustomField], [, /*bKey*/ bCustomField]) =>
                        // Sort custom fields according to its 'order'
                        this._CustomFieldsEntityDef
                            .getSortingComparator("order")
                            .call(null, aCustomField, bCustomField)
                    )
                    .map(([key, customField], idx) => {
                        // Build grid column object for each custom field
                        const predefinedCustomField = _.find(DEVICE_CUSTOM_FIELDS, {id: key});
                        const columnRendererComponent = _.get(
                            predefinedCustomField,
                            "columnRenderer",
                            CustomFieldsColumn
                        );
                        const customFieldColumn = {
                            label: customField.label,
                            description: customField.description || customField.label,
                            entityColumn: false,
                            shown: false,
                            path: `customFieldValues.${key}`,
                            dataType: String(customField.dataType).toLowerCase(),
                            typeInfo: customField.typeInfo || {},
                            context: _.clone(customField),
                            columnRendererComponent,
                        };

                        const {labels, ids, multiSelect} = customFieldColumn.typeInfo || {};
                        if (labels && ids && multiSelect !== true) {
                            customFieldColumn.options = ids.reduce(
                                (options, id, idx) =>
                                    Object.assign(options, {[id]: {title: labels[idx]}}),
                                {}
                            );
                        }

                        return {[key]: customFieldColumn};
                    });

                if (!this._isCiscoSupportEnabled && this._isNistSupportEnabled) {
                    const type1CustomFields = _.map(
                        DEVICE_CUSTOM_FIELDS.filter((i) => i.type === 1),
                        "id"
                    );

                    enabledCustomColumns = enabledCustomColumns.filter((obj) => {
                        const key = Object.keys(obj)[0];

                        if (_.indexOf(type1CustomFields, key) > -1) {
                            return false;
                        }
                        return true;
                    });
                }

                _.assign(this.columnConfig, ...enabledCustomColumns);

                // Optimise column width if needed
                const PIXELS_PER_CHAR = 8;
                const PADDING = 13;
                const MIN_WIDTH = 45;
                const MAX_WIDTH = 300;
                Object.keys(this.columnConfig).forEach((columnKey) => {
                    // Set width based on label length
                    const labelLength = this.columnConfig[columnKey].label?.length || 0;
                    const labelWidth = labelLength * PIXELS_PER_CHAR + PADDING;
                    const width = Math.max(MIN_WIDTH, Math.min(labelWidth, MAX_WIDTH));

                    if (
                        !_.isNumber(this.columnConfig[columnKey].width) ||
                        this.columnConfig[columnKey].width < width
                    ) {
                        this.columnConfig[columnKey].width = width;
                    }
                });

                const basicFilterQuery = _.get(
                    this._userGridData.getBasicSearchData(),
                    "filterQuery",
                    {}
                );
                const advancedFilterQuery = this._userGridData.getAdvancedSearchData();

                const userSorting = this._userGridData.getSorting() || {};

                this._patchSorting(userSorting);

                let filterQuery = !_.isEmpty(advancedFilterQuery)
                    ? advancedFilterQuery
                    : basicFilterQuery;
                const oldQuery = _.clone(filterQuery);
                switch (this._solutionName) {
                    case "config_drift":
                        filterQuery = {
                            $userQuery: oldQuery,
                            $systemQuery: {managementState: {$in: ["MANAGED", "UNMANAGED"]}},
                        };
                        break;
                    case "os_manager":
                        filterQuery = {
                            $userQuery: oldQuery,
                            $systemQuery: (await OsUpgradePlanEntity.getOsUpgradeDeviceQuery(
                                this._gameEditor._activeOrgId
                            )) || {
                                $and: [
                                    {
                                        discoveryStatus: "DISCOVERED",
                                    },
                                    {
                                        managementState: "MANAGED",
                                    },
                                ],
                            },
                        };
                        break;
                    case "device_manager":
                    case "data_explorer":
                    default:
                        filterQuery = {
                            $userQuery: oldQuery,
                            $systemQuery: {},
                        };
                        break;
                }
                if (selectedSite) {
                    // console.log(selectedSite, this.treeData);
                    const {pathVals, selectedSitePath} = TreeUtils.getAllChildrenPathsFromId(
                        this.treeData,
                        selectedSite
                    );
                    if (selectedSitePath === "/") {
                        this._filterForTree = {};
                    } else if (pathVals) {
                        this._filterForTree = {sitePath: {$in: pathVals}};
                    }
                    // this._updateFilter("ontoggle", false, false);
                }
                if (typeof filterQuery !== "object") {
                    filterQuery = {};
                }
                let _filter = JSON.parse(JSON.stringify(filterQuery));

                // Initialize $userQuery if it doesn't exist
                _filter.$systemQuery = _filter.$systemQuery || {};

                // Ensure $userQuery.$and exists and is an array
                if (!_filter.$systemQuery.$and || !Array.isArray(_filter.$systemQuery.$and)) {
                    _filter.$systemQuery.$and = [];
                }

                // Always append deviceRawCategory not equal to 'iot' to $and
                _filter.$systemQuery.$and.push({deviceRawCategory: {$ne: "iot"}});

                if (!_.isEmpty(this._filterForTree)) {
                    let userQ = {};
                    if (_filter.$userQuery) {
                        if (_filter.$userQuery.$and) {
                            userQ.$and = _filter.$userQuery.$and;
                        } else if (_filter.$userQuery.$or) {
                            userQ.$and = [{$or: _filter.$userQuery.$or}];
                        } else {
                            userQ.$and = [];
                        }
                    } else {
                        userQ.$and = [];
                    }
                    userQ.$and.push(this._filterForTree);
                    _filter.$userQuery = userQ;
                }
                this._pagingDeviceFeed = new PagingDeviceFeed({
                    feedKey: this._gridKey + "_feed",
                    activeOrgId: this.activeOrgId,
                    entityDef: this._DeviceEntityDef,
                    columnConfig: this.columnConfig,
                    filter: _filter,
                    sort: userSorting,
                    additionalDataFields,
                });
                this._registerListeners();
                // return this._CustomFieldsEntityDef.retrieveCustomFields(this.activeOrgId);
                // })
                // .then((customColumnsEntity) => {
                this._customFieldColumnsEntity = customColumnsEntity;
                this._registerUpdatedColumnListeners();
            })
            .then(() => {
                if (this._solutionName === "os_manager") {
                    this._imageServersFeed = this._establishImageServersFeed(this.activeOrgId).then(
                        () => {
                            this._statusBar = this._initStatusBar();
                            return this.whenFeedIsReady();
                        }
                    );
                } else {
                    return this.whenFeedIsReady();
                }
            })
            .then(() => {
                return this._credentialsEntityDef
                    .loadLabelValues(this._gameEditor._activeOrgId, {$exists: true})
                    .then((results) => {
                        results.forEach(
                            ({label}) =>
                                (this._credentialNameOptions[label] = {name: label, title: label})
                        );

                        Object.assign(this.columnConfig.credsName, {
                            options: this._credentialNameOptions,
                        });
                    });
            });
    }
    wasFeedPreviouslyInitialized() {
        return this._pagingDeviceFeed.wasPreviouslyInitialized();
    }

    whenFeedIsReady() {
        return this._pagingDeviceFeed.whenFeedReady();
    }

    get renderer() {
        return this._renderer;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterFeedListeners();
        this._unregisterListeners();
        this._unregisterUpdatedColumnListeners();
        let shutdowns = [
            this._renderer.shutdown(),
            _.isUndefined(this._pagingDeviceFeed)
                ? Promise.resolve()
                : this._pagingDeviceFeed.shutdown(),
            _.isUndefined(this._sessionStorage)
                ? Promise.resolve()
                : this._sessionStorage.shutdown(),
        ];

        return Promise.all(shutdowns).then(
            () => {
                //this._gameEditor._unregisterDeviceExplorerListeners();
                this._gameEditor = undefined;
                this._renderer = undefined;
                this._steveUtils = undefined;
                this._explorerState = undefined;
                this._pagingDeviceFeed = undefined;
                this._VendorApiConfigEntityDef = undefined;
                this._isCiscoSupportEnabled = undefined;
                this._isNistSupportEnabled = undefined;
                this._DeviceEntityDef = undefined;
                this._userSession = undefined;
                this._controlledDeviceNames = undefined;
                this._controlledDeviceIDs = undefined;
                this._modalUserFeedback = undefined;
                this._solutionsManager = undefined;
                this._solutionName = undefined;
                this._gridKey = undefined;
                this._userGridData = undefined;
                this._sessionStorage = undefined;
                this._logger = undefined;
                this._customFieldColumnsEntity = undefined;
                this._isEmitCustomFieldEvent = undefined;
                this._siteEntityDef = undefined;
                this._constructTypeEntityDef = undefined;
                this._nodeProps = undefined;
                this._TagsEntity = undefined;
                this._tags = undefined;
                this._tagOptions = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "DeviceGridViewComponent.shutdown() error");
            }
        );
    }

    get gameEditor() {
        return this._gameEditor;
    }

    get explorerState() {
        return this._explorerState;
    }

    set explorerState(val) {
        this.setExplorerState(val);
    }

    setExplorerState(val) {
        this._explorerState = val;
    }

    updateExplorerState(property, val) {
        if (val === undefined) {
            this._sessionStorage.removeData(property);
            _.unset(this._explorerState, property);
        } else {
            this._sessionStorage.setData(val, property);
            _.set(this._explorerState, property, val);
        }
    }

    get isCiscoSupportEnabled() {
        return this._isCiscoSupportEnabled;
    }

    set isCiscoSupportEnabled(isEnabled) {
        this._isCiscoSupportEnabled = isEnabled;
    }

    get isNistSupportEnabled() {
        return this._isNistSupportEnabled;
    }

    set isNistSupportEnabled(isEnabled) {
        this._isNistSupportEnabled = isEnabled;
    }

    resetSelection(newIds) {
        let selectedIds = [];

        if (newIds && newIds.length) {
            newIds.forEach((id) => {
                selectedIds.push(id);
            });
        }

        this.renderer._deviceEntityGrid.setSelectedRows(selectedIds);
        this.updateExplorerState("selectedIds", {selectedRows: selectedIds});
        this.renderer._renderAvailableActions();
    }

    loadAndScrollTo(entityId) {
        let that = this;
        this.pagingFeed.on("RequestedEntityFound", handleRequestedEntityFound);
        this.pagingFeed._requestEntity(entityId);

        function handleRequestedEntityFound(index) {
            that.renderer._deviceEntityGrid.renderer.scrollToTheRow(index);
            that.pagingFeed.removeListener("RefreshView", handleRequestedEntityFound);
        }
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onEditorClosed(tabId /*, editorParams*/) {
        //let editorsIds = editorParams.launchOptions.deviceIds;
        if (this._explorerState.openedTabs[tabId]) {
            delete this._explorerState.openedTabs[tabId];
            if (
                Object.keys(this._explorerState.openedTabs).length === 1 &&
                this._explorerState.openedTabs.sessionToken
            ) {
                delete this._explorerState.openedTabs.sessionToken;
            }
        }
        if (this._explorerState.activeTab === tabId) {
            if (!_.isEmpty(this._explorerState.openedTabs)) {
                let openedTabsIds = Object.keys(this._explorerState.openedTabs);
                this.updateExplorerState("activeTab", openedTabsIds[openedTabsIds.length - 1]);
            } else {
                this.updateExplorerState("activeTab", undefined);
            }
        }
        this.updateExplorerState("openedTabs", this._explorerState.openedTabs);
    }

    _onActiveTabChanged(tabId /*, editorParams*/) {
        if (this._explorerState.activeTab !== tabId) {
            this.updateExplorerState("activeTab", tabId);
        }
    }

    _onEditorLaunched(editorState, launchOpts) {
        if (!this._explorerState.openedTabs[launchOpts.id]) {
            let openedTab = Object.assign(editorState, launchOpts);
            this._explorerState.openedTabs[launchOpts.id] = openedTab;
            this.updateExplorerState("openedTabs", this._explorerState.openedTabs);
        }
        this.updateExplorerState("activeTab", launchOpts.id);
    }

    onUserSorted(sortData) {
        sortData = [].concat(sortData);
        let sort = {};

        sortData.forEach((sortData) => {
            if (!sortData || !sortData.sortColumn || !this.columnConfig[sortData.sortColumn]) {
                return;
            }
            const sortCriteria =
                this.columnConfig[sortData.sortColumn].valuePath ||
                this.columnConfig[sortData.sortColumn].path ||
                sortData.sortColumn;
            sort[sortCriteria] = sortData.sort === "asc" ? 1 : -1;
        });

        this._patchSorting(sort);

        this._pagingDeviceFeed.setSort(sort);
    }

    _onSolutionChanged(solution) {
        // whole pane will be reset, no need to make any action here
        this._solutionName = solution.name;
    }

    _onStorageReady() {}

    _onPropertiesUpdated(pristineProperties, before) {
        this._isEmitCustomFieldEvent = false;
        let updatedColumnKeys = pristineProperties.fields;
        let previousColumnKeys = before.fields;
        let editedColumn = Object.assign(
            {},
            ..._.reduce(
                updatedColumnKeys,
                (result, value, key) => {
                    return _.isEqual(value, previousColumnKeys[key])
                        ? result
                        : result.concat({
                              [key]: value,
                          });
                },
                []
            )
        );
        if (Object.keys(updatedColumnKeys).length !== Object.keys(previousColumnKeys).length) {
            this._isEmitCustomFieldEvent = true;
        } else {
            for (let key of Object.keys(editedColumn)) {
                if (
                    !updatedColumnKeys[key].enabled &&
                    updatedColumnKeys[key].enabled === previousColumnKeys[key].enabled
                ) {
                    this._isEmitCustomFieldEvent = false;
                } else {
                    this._isEmitCustomFieldEvent = true;
                    break;
                }
            }
        }
        if (this._isEmitCustomFieldEvent) {
            this.emit("GridColumnUpdated", pristineProperties, before);
        }
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    async _establishImageServersFeed(orgId) {
        if (!orgId) {
            return;
        }
        const query = {};
        const fields = [
            "enabled",
            "name",
            "identifier",
            "ip",
            "status",
            "percentFull",
            "isMain",
        ].reduce((fields, field) => Object.assign(fields, {[field]: true}), {});

        const sort = {createdOn: 1};
        if (this._imageServersFeed) {
            await this._imageServersFeed.whenInitialized();
            await this._imageServersFeed.reestablishFeed(orgId, query, fields, sort);
        } else {
            this._imageServersFeed = await this._osImageServerEntity.startAscendOsImageServersFeed(
                orgId,
                query,
                fields,
                sort
            );
            this._registerImageServersFeedListeners(this._imageServersFeed);
        }

        return this._imageServersFeed;
    }

    _initStatusBar() {
        this._defaultDiOpts = {
            defaultInjectables: ["$teve.logger", "eventEmitter.eventEmitter"],
        };

        let diOpts = _.cloneDeep(this._defaultDiOpts) || {};
        diOpts.injectableOverrides = {
            //"gameEditor.gameEditor": this
            "eventEmitter.eventEmitter": this,
        };

        return this._di.createInstance(Registrations.DEVICE_EXPLORER_STATUS_BAR, diOpts);
    }

    _onImageServerFeedUpdate(feed) {
        this.emit("ImageServersUpdated", feed.getCacheAsArray());
    }

    _registerImageServersFeedListeners(feed) {
        const onFeedUpdate = _.debounce(this._onImageServerFeedUpdate.bind(this), 0);

        feed.on("ChangeFeedInitialized", (data, feed /*, reInit*/) => {
            onFeedUpdate(feed, "ChangeFeedInitialized");
        })
            .on("EntityInitialized", () => {
                onFeedUpdate(feed, "EntityInitialized");
            })
            .on("EntityPropertiesUpdated", (entity, patches, props, feed) => {
                onFeedUpdate(feed, "EntityPropertiesUpdated");
            })
            .on("EntityAdded", (entity, properties, feed) => {
                onFeedUpdate(feed, "EntityAdded");
            })
            .on("EntityRemoved", (entity, cause, feed) => {
                onFeedUpdate(feed, "EntityRemoved");
            })
            .once("ShutdownStarted", () => {
                onFeedUpdate.cancel();
                feed.removeListener("ChangeFeedInitialized", onFeedUpdate)
                    .removeListener("EntityInitialized", onFeedUpdate)
                    .removeListener("EntityPropertiesUpdated", onFeedUpdate)
                    .removeListener("EntityAdded", onFeedUpdate)
                    .removeListener("EntityRemoved", onFeedUpdate);
            });
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    openDeviceInstanceEditor(ids, fullyQualifiedViewName) {
        if (Array.isArray(ids) && ids.length > 1) {
            this._gameEditor.launchDeviceMultiEditor(ids);
        } else if ((Array.isArray(ids) && ids.length) || (typeof ids === "string" && ids !== "")) {
            const id = Array.isArray(ids) ? ids[0] : ids,
                fqn = fullyQualifiedViewName || Registrations.DIE_VIEW_DETAILS,
                device = this._pagingDeviceFeed.getDeviceEntityById(id),
                title = _.get(device, "name", "");
            this._gameEditor.launchDeviceEditor(
                {
                    fqn,
                },
                {
                    id,
                    title,
                }
            );
        }
    }

    openNetworkDiscoveryEditor(ids = [], openFromUrl = false) {
        let editorState = {
            fqn: Registrations.NETWORK_DISCOVERY_EDITOR_VIEW_DETAILS,
        };
        let launchOpts = {
            id: this.activeOrgId,
            title: "Network Discovery",
            type: "NetworkDiscovery",
            selectedDevice: ids || [],
            openFromURL: openFromUrl,
        };
        this._gameEditor.launchNetworkDiscoveryEditor(editorState, launchOpts);
    }

    getSelectedDeviceIds() {
        return _.get(this._explorerState, "selectedIds", []);
    }

    _resolveLicenseFlags() {
        return applyExposureLicenseGate({
            licenseRestriction: this._licenseRestriction,
            logger: this._logger,
        }).then(({licensed}) => {
            this._TAILicenseEnabled = licensed;
            this._CDALicenseEnabled = this._hasAccessToCDA();
            this.columns = undefined;
        });
    }

    _hasAccessToCDA() {
        const authorizedActions = _.get(this._userSession, "_userEntity.authorizedActions") || [];
        const hasPermission = authorizedActions.some(
            (action) => action === "configDriftAndAuditAccess"
        );
        const hasLicense = this._licenseRestriction.checkLicense("CDA");

        if (hasPermission && hasLicense) {
            return true;
        }
        return false;
    }

    _getOsPlanDataForAdvancedFilter(data) {
        let clonedData = _.clone(data);
        let newObj = {};
        for (let key in clonedData) {
            let value = {};
            value[key] = {
                name: key,
                title: clonedData[key],
            };
            newObj = Object.assign(newObj, value);
        }
        return newObj;
    }

    async _getNodeProps() {
        this._nodeProps = await this._constructTypeEntityDef.getDeviceNodePropDefs(
            this.activeOrgId
        );
        return Promise.resolve();
    }

    // Options for the id-based Tags filter: the DB value is the tag id, the display is its name.
    async _getAllTags() {
        this._tags = await this._TagsEntity.loadTags(this.activeOrgId);
        return this._tags.map(({id, name}) => ({name: id, title: name}));
    }

    async _getExtendedPropTypes() {
        this._extendedPropTypes = await this._extendedPropTypeEntityDef.loadExtendedPropTypes(
            this.activeOrgId,
            {
                enabled: {$ne: false},
                $or: [
                    {schemaTypes: {$exists: false}},
                    {schemaTypes: {$size: 0}},
                    {schemaTypes: "network"},
                ],
            }
        );

        if (this._extendedPropTypes.length > 0) {
            const edpColumns = {};

            this._extendedPropTypes.forEach((extendedPropType) => {
                const {deviceExplorerFieldMap: columns, extensionType} =
                    extendedPropType.getPristineProperties();

                Object.entries(columns).forEach(([key, value]) => {
                    const columnKey = `edpValues.${extensionType}.${key}`;
                    const columnConfig = {
                        label: value.displayName,
                        dataType: value.dataType,
                        shown: false,
                        path: columnKey,
                    };

                    // Add options if enum type
                    if (value.dataType === "enum") {
                        const options = {};
                        if (Array.isArray(value.options)) {
                            value.options.forEach((val) => {
                                options[val] = {name: val, label: val};
                            });
                        } else {
                            Object.entries(value.options).forEach(([key, val]) => {
                                options[key] = {name: val, label: key};
                            });
                        }
                        columnConfig.options = options;
                    }

                    // Add groupable if applicable
                    if (value?.display?.groupable) {
                        columnConfig.groupable = true;
                    }

                    edpColumns[columnKey] = columnConfig;
                });
            });

            Object.assign(this.columnConfig, edpColumns);
        }

        return Promise.resolve();
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = DeviceGridViewComponent;

DeviceGridViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.utils",
    "$teve.entities.Device",
    "$teve.entities.VendorApiConfig",
    "$teve.entities.CustomFields",
    "$teve.userSession",
    "$teve.storageFactory",
    "$teve.solutionsManager",
    "$teve.ui.userFeedback",
    "$teve.licenseRestriction",
    "$teve.entities.OsImageServer",
    "$teve.di",
    "$teve.entities.Site",
    "$teve.entities.Credentials",
    "$teve.entities.ConstructType",
    "$teve.entities.ExtendedPropType",
    "$teve.entities.Tags",
];

DeviceGridViewComponent.$displayDetails = {
    type: "View",
    name: "",
    icon: "configdrift.device",
    shown: false,
    order: 1,
};
